import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const HistoryContentSkeleton = () => (
  <Styles.Container>
    <Skeleton height={20} width="40%" />
    <Skeleton height={50} />
    <Skeleton height={50} />
    <Skeleton height={50} />
  </Styles.Container>
)

export default HistoryContentSkeleton
